import { render, staticRenderFns } from "./VideoBoostAccountStats.vue?vue&type=template&id=22886b84&"
import script from "./VideoBoostAccountStats.vue?vue&type=script&lang=js&"
export * from "./VideoBoostAccountStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports